import React, { useState, useRef } from 'react';
import { Typography, Box } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import './NumberInput.css';

export const NumberInput = ({ label, value, onChange, min, max, ...props }) => {
    const [inputValue, setInputValue] = useState(() => (value === 0 ? '' : String(value)));
    const inputRef = useRef(null);
    const isFocused = useRef(false);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleBlur = () => {
        isFocused.current = false;
        let numericValue = parseFloat(inputValue);
        if (isNaN(numericValue)) {
            numericValue = 0;
        }
        if (min !== undefined && numericValue < min) numericValue = min;
        if (max !== undefined && numericValue > max) numericValue = max;
        onChange(numericValue);
        setInputValue(numericValue === 0 ? 0 : String(numericValue));
    };

    const handleFocus = () => {
        isFocused.current = true;
    };

    const handleIncrement = () => {
        let newValue = value + 1;
        if (max !== undefined && newValue > max) newValue = max;
        onChange(newValue);
        setInputValue(newValue === 0 ? 0 : String(newValue));
    };

    const handleDecrement = () => {
        let newValue = value - 1;
        if (min !== undefined && newValue < min) newValue = min;
        onChange(newValue);
        setInputValue(newValue === 0 ? 0 : String(newValue));
    };

    return (
        <Box className="speakers-input-container">
            <Typography>{label}</Typography>
            <div className="number-input-wrapper">
                <input
                    ref={inputRef}
                    type="text"
                    inputMode="numeric"
                    className="speakers-input-field outline-disabled"
                    value={inputValue}
                    onChange={handleInputChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    {...props}
                />
                <div className="custom-spin-buttons">
                    <button
                        type="button"
                        className="spin-btn up"
                        onClick={handleIncrement}
                        tabIndex={-1}
                    >
                        <ArrowDropUpIcon fontSize="small" />
                    </button>
                    <button
                        type="button"
                        className="spin-btn down"
                        onClick={handleDecrement}
                        tabIndex={-1}
                    >
                        <ArrowDropDownIcon fontSize="small" />
                    </button>
                </div>
            </div>
        </Box>
    );
};